// extracted by mini-css-extract-plugin
module.exports = {"text":"_2LI1BwtL _1EH-ihlL _1_WwV6pt jM9aIwSB _1m8vMwqD"};